// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React, {useState} from 'react';

import {EntityQuery} from '../../generated/graphql';
import {TeamSettingsPageEntity} from '../../graphql/teamQuery';
import TriggerRunsV2Modal from './TriggerRunsV2Modal';

interface EntityRunsV2SectionProps {
  entity: TeamSettingsPageEntity | EntityQuery['entity'];
}

const EntityRunsV2Section: React.FC<EntityRunsV2SectionProps> = ({entity}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="mt-4">
      <Button onClick={() => setIsModalOpen(true)}>
        Trigger runs v2 backfill
      </Button>
      <TriggerRunsV2Modal
        name={entity?.name ?? ''}
        type="entity"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default EntityRunsV2Section;
